import { createContext } from '@lyearn/core/utils/context';
import useHomeEditor from '@/modules/corporate/modules/home/views/Editor/hooks/useHomeEditor';
import { LanguageEnum } from '@/types/schema';

const HOME_EDITOR_CONTEXT_NAME = 'HomeEditor';

type UseHomeEditorReturnType = ReturnType<typeof useHomeEditor> & {
  selectedLanguage?: LanguageEnum;
  setSelectedLanguage?: React.Dispatch<React.SetStateAction<LanguageEnum>>;
};

export const [HomeEditorContextProvider, useHomeEditorContext] =
  createContext<Omit<UseHomeEditorReturnType, 'fetching' | 'error'>>(HOME_EDITOR_CONTEXT_NAME);
